import { IconButton } from '@/components/IconButton';
import { Stack, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '@/hooks';
import { oauthClients } from './oauth';

export function OAuthButtons({ type, authTrigger, ...props }) {
	const { t } = useTranslation();
	const language = useLanguage();

	const inactiveItems = ['tiktok', 'apple'];

	const buttonTexts = {
		google: t(type === 'login' ? 'oauth.loginWith' : 'oauth.signUpWith', {
			provider: 'google'
		})
	};

	const buttons = oauthClients
		.map(client => {
			if (inactiveItems.includes(client.provider)) return null;

			return {
				name: client.name,
				href: client.getUrl({
					type,
					language,
					authTrigger
				}),
				image: client.image,
				provider: client.provider
			};
		})
		.filter(Boolean);

	return (
		<Stack direction="row" alignItems="center" spacing={1} py={2} {...props}>
			{buttons.map(({ image, name, href, provider }) => {
				const buttonText = buttonTexts?.[provider];

				return (
					<Tooltip
						key={name}
						title={t(
							type === 'login' ? 'oauth.loginWith' : 'oauth.signUpWith',
							{ provider: name }
						)}
						arrow
					>
						<IconButton
							key={name}
							fullWidth
							href={href}
							variant="outlined"
							sx={{ flex: buttonText ? 14 : 1, minWidth: 40 }}
						>
							<img src={image} alt={name} width="24" height="24" />
							{buttonText && (
								<Typography
									sx={{ ml: 1 }}
									variant="body1"
									fontWeight={500}
								>
									{buttonText}
								</Typography>
							)}
						</IconButton>
					</Tooltip>
				);
			})}
		</Stack>
	);
}
